import { INK } from '../Landing/ui';
import { fraunces } from '../Landing/fonts';

// Top things to do as numbered route stops — dashed-circle badges in the
// Landing itinerary idiom. External links are partner links (nofollow).
export default function ThingsToDoList({ topThingsToDo, funFact }) {
  if (!topThingsToDo || topThingsToDo.length === 0) return null;

  return (
    <div className="tw-grid tw-items-start tw-gap-10 lg:tw-grid-cols-[1fr_minmax(0,22rem)]">
      <ol className="tw-m-0 tw-grid tw-list-none tw-gap-x-10 tw-gap-y-5 tw-p-0 sm:tw-grid-cols-2">
        {topThingsToDo.map((thingToDo, i) => (
          <li
            key={thingToDo.activity}
            className="tw-flex tw-items-start tw-gap-4"
          >
            <span className="tw-mt-0.5 tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-dashed tw-border-primary-600 dark:tw-border-primary-300 tw-font-mono tw-text-xs tw-font-semibold tw-text-primary-700 dark:tw-text-primary-300">
              {i + 1}
            </span>
            <span className={`${INK} tw-text-[15px] tw-leading-relaxed`}>
              {thingToDo.externalLink ? (
                <a
                  href={thingToDo.externalLink}
                  target="_blank"
                  rel="nofollow noreferrer noopener"
                  className="tw-font-semibold tw-text-inherit tw-underline tw-decoration-dotted tw-underline-offset-2 hover:tw-text-primary-700 dark:hover:tw-text-primary-300"
                >
                  {thingToDo.activity}
                  <span aria-hidden="true"> ↗</span>
                </a>
              ) : (
                <span className="tw-font-semibold">{thingToDo.activity}</span>
              )}
            </span>
          </li>
        ))}
      </ol>

      {funFact && (
        <aside className="tw-max-w-md -tw-rotate-1 tw-rounded-xl tw-border tw-border-dashed tw-border-[#C9C0AA] dark:tw-border-[#3A4D44] tw-bg-[#FFFDF6] dark:tw-bg-[#15231E] tw-p-5">
          <p className="tw-m-0 tw-font-mono tw-text-[9px] tw-font-medium tw-uppercase tw-tracking-[0.25em] tw-text-[#8A958F]">
            From the field notes
          </p>
          <p
            className={`${fraunces.className} ${INK} tw-m-0 tw-mt-2 tw-text-lg tw-font-medium tw-italic tw-leading-snug`}
          >
            {funFact}
          </p>
        </aside>
      )}
    </div>
  );
}
